import { NgModule } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterModule,
  RouterStateSnapshot,
  Routes,
  UrlMatchResult,
  UrlSegment,
} from "@angular/router";

import { QuoteListComponent } from "./quote-list/quote-list.component";

import { NgxPermissionsGuard } from "ngx-permissions";
import { role } from "../user/role.const";
import { QuoteFormComponent } from "./quote-form/quote-form.component";
import { QuoteResolver } from "./quote-form/quote.resolver";
import { QuoteCreateComponent } from "./quote-create/quote-create.component";
import { AgentRequestListComponent } from "./agent-request-list/agent-request-list.component";

export function getUserPermissions(
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) {
  return [role.user];
}

// `quote/:id` and `quote/:id/:displayId` share a single route config on purpose: the form swaps
// the url in place once a quote is created, and only the same config lets the router reuse the
// component instead of destroying it (which would delete the quote as an empty one).
export function quoteFormMatcher(
  segments: UrlSegment[],
): UrlMatchResult | null {
  if (segments.length === 1) {
    return { consumed: segments, posParams: { id: segments[0] } };
  }

  if (segments.length === 2) {
    return {
      consumed: segments,
      posParams: { id: segments[0], displayId: segments[1] },
    };
  }

  return null;
}

export const routes: Routes = [
  {
    path: "quote",
    children: [
      {
        path: "",
        redirectTo: "list",
        pathMatch: "full",
      },
      {
        path: "list",
        component: QuoteListComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: getUserPermissions,
            redirectTo: "/",
          },
        },
      },
      {
        path: "requests",
        component: AgentRequestListComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: getUserPermissions,
            redirectTo: "/",
          },
        },
      },
      {
        path: "create/:clientRef/:quoteRef",
        component: QuoteCreateComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: getUserPermissions,
            redirectTo: "/",
          },
        },
      },
      {
        matcher: quoteFormMatcher,
        component: QuoteFormComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: getUserPermissions,
            redirectTo: "/",
          },
        },
        resolve: {
          quote: QuoteResolver,
        },
      },
    ],
    data: { state: "quote-list" },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [QuoteResolver],
})
export class QuoteRoutingModule {}
